import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import ModalOverlay from '../../common/ModalOverlay'
import closeImg from '../../../assets/close.svg'
import image from '../../../assets/my-decor-modal.png'

const Container = styled.div`
  height: 500px;
  width: 530px;
  border-radius: 16px;
  position: relative;

  max-width: 90vw;
  max-height: 90vh;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  margin: auto;
`

const Title = styled.div`
  font-family: Helvetica Neue;
  font-size: 24px;
  font-weight: 700;
  line-height: 29px;
  margin-bottom: 22px;
`

const Description = styled.div`
  font-family: Helvetica Neue;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
  width: 340px;
  margin-bottom: 22px;

  & span {
    color: #ff5e6d;
    display: block;
  }
`

const Button = styled.button`
  height: 42px;
  width: 236px;
  border-radius: 32px;
  border: none;
  background-color: #ff5e6d;
  color: #fff;

  font-family: Helvetica Neue;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  cursor: pointer;
`

const Image = styled.img`
  height: auto;
  width: 214px;
  max-width: 90%;
  object-fit: contain;
  margin-bottom: 40px;
`

export const CloseButton = styled.button`
  position: absolute;
  top: 21px;
  right: 17px;
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  cursor: pointer;

  & img {
    width: 15px;
    height: 15px;
  }
`

export const MyDecorModal = ({
  handleClose,
  isMember,
  handleShowMembershipModal
}) => {
  return (
    <ModalOverlay fullscreen onClose={handleClose}>
      <Container>
        <Image src={image} />
        <Title>What is MyDecor</Title>
        <Description>
          You can upload your own photos into MyDecor to create your designs!
          <span>(Membership Only)</span>
        </Description>
        <Button onClick={isMember ? handleClose : handleShowMembershipModal}>
          {isMember ? 'Got it' : 'Become a Member'}
        </Button>
        <CloseButton onClick={handleClose}>
          <img src={closeImg} alt="close" />
        </CloseButton>
      </Container>
    </ModalOverlay>
  )
}

export default MyDecorModal
